'use client';

import { Content, asText } from '@prismicio/client';

import { Box, Heading } from '@preventx/oxygen';

// Components
import { VimeoContainer } from '@/components/Display/VimeoContainer';
import { RichTextDefault } from '@/components/RichText/RichTextDefault';

type WithVimeoProps = {
  slice: Content.RegionSliceWithVimeo;
};

export const WithVimeo = ({ slice }: WithVimeoProps) => {
  const { primary } = slice;
  const { title, content, video_id, video_position, video_caption } = primary;

  return (
    <Box
      addFlow
      component="div"
      addSwitcher={video_position === 'Left' || video_position === 'Right'}
    >
      {(video_position === 'Top' || video_position === 'Left') && (
        <VimeoContainer
          caption={video_caption}
          vimeoId={video_id ?? undefined}
        />
      )}

      <Box component="div" addFlow>
        <Heading component="h2" className="headline__title">
          {asText(title)}
        </Heading>

        <RichTextDefault content={content} />
      </Box>

      {(video_position === 'Default' ||
        video_position === 'Bottom' ||
        video_position === 'Right') && (
        <VimeoContainer
          caption={video_caption}
          vimeoId={video_id ?? undefined}
        />
      )}
    </Box>
  );
};
